import React, { Fragment } from 'react'

import { Socials } from 'src/interfaces/Attraction'

import { getServiceProfileUrl, getSocialData } from '../attractions-helper'
import { SOCIAL_NETWORKS } from '../../constants'

interface Props {
  socials: Socials,
}

export const SocialBar = ({ socials }: Props) => (
  <Fragment>
    {
      Object.keys(SOCIAL_NETWORKS)
        .map((media) => {
          const { Icon, params } = SOCIAL_NETWORKS[media]
          const { key, value } = getSocialData(socials, media)
          return value && (
            <a
              key={media}
              href={getServiceProfileUrl(key, value)}
              target="_blank"
            >
              <Icon {...params} />
            </a>
          )
        })
    }
  </Fragment>
)
